<template>
  <section class="encardGame">
    <!--<img src="../assets/background/degradeBackground.png" alt="encardBg" id="encardBg" class="encardBg">-->
    <div class="smartphone-content">
      <div class="smartphone-template">
        <div class="smartphone-video">
          <iframe
            id="ytplayer"
            type="text/html"
            width="277"
            height="481"
            src="https://www.youtube.com/embed/3qrRUPKytqI"
            frameborder="0"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "EncardGameSnowy",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.encardGame {
  position: relative;
  img {
    position: absolute;
  }
  .smartphone-content {
    position: relative;
    .smartphone-template {
      background: url('../assets/smartphone.png');
      background-position: center;
      background-repeat: no-repeat;
      background-attachment: scroll;
      background-size: cover;
      height: 587px;
      width: 306px;
      margin: 0 auto;
      .smartphone-video {
        overflow: hidden;
        margin: 0 14px 0 16px;
        padding: 55px 0px 50px 0px;
        height: 100%;
        border-radius: 70px;
      }
    }
  }
}
</style>
